import type { ArbiterState } from '../state/store';

/** Minimum segment length (ms) that warrants a single STT retry on blank transcript. */
export const EMPTY_STT_RETRY_MIN_MS = 500;

/**
 * Whether to retry main-lane STT after a blank result.
 * Only the first attempt (`attempt === 0`) may retry, and only for substantial segments.
 */
export function shouldRetryEmptyStt(segmentDurationMs: number, attempt: number): boolean {
  return attempt === 0 && segmentDurationMs >= EMPTY_STT_RETRY_MIN_MS;
}

/**
 * Arbiter UI state after a final empty/failed main-lane STT.
 * Never leave the bar on `thinking` solely because of a blank transcript.
 */
export function arbiterStateAfterEmptyStt(assistantAudible: boolean): Exclude<ArbiterState, 'thinking'> {
  return assistantAudible ? 'speaking' : 'listening';
}
